/**
 * 菜品数据本地持久化（localStorage）
 * 刷新页面不丢失；无后端接口。
 */
import { isValidCategory } from '@/constants/categories'
import { SEED_DISHES } from '@/constants/seedDishes'

const STORAGE_KEY = 'foodtoge_dishes'
const SEED_FLAG = 'foodtoge_seed_v2'

/**
 * 旧数据可能没有 category，一律记为普通菜
 */
function normalizeDish(dish) {
  if (!dish || typeof dish !== 'object') return null
  const category = isValidCategory(dish.category) ? dish.category : 'normal'
  return {
    id: String(dish.id || ''),
    name: String(dish.name || ''),
    price: Number(dish.price),
    cost: Number(dish.cost),
    category
  }
}

/**
 * 读取全部菜品
 * @returns {Array<{id: string, name: string, price: number, cost: number, category: string}>}
 */
export function loadDishes() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    let list = []
    if (raw) {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) list = parsed.map(normalizeDish).filter(Boolean)
    }
    return ensureSeedDishes(list)
  } catch (e) {
    return ensureSeedDishes([])
  }
}

/**
 * 首次（或尚未写入过示例标记）把示例菜谱补进列表，不覆盖用户已有同名菜品
 */
function ensureSeedDishes(list) {
  const seeded = window.localStorage.getItem(SEED_FLAG) === '1'
  let next = list
  if (!seeded) {
    const seedById = {}
    SEED_DISHES.forEach((d) => {
      seedById[d.id] = d
    })
    next = list.map((d) => {
      const seed = seedById[d.id]
      if (!seed) return d
      return normalizeDish({ ...d, price: seed.price, cost: seed.cost, category: seed.category })
    })
  }
  if (seeded && next.length) return next
  const names = new Set(next.map((d) => d.name))
  const extra = SEED_DISHES
    .filter((d) => !names.has(d.name))
    .map(normalizeDish)
    .filter(Boolean)
  const merged = extra.length ? next.concat(extra) : next
  if (merged.length) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
    window.localStorage.setItem(SEED_FLAG, '1')
  }
  return merged
}

/**
 * 覆盖写入全部菜品
 */
export function saveDishes(dishes) {
  const list = (dishes || []).map(normalizeDish).filter(Boolean)
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
}

/**
 * 生成菜品 id（时间戳 + 随机数）
 */
export function createDishId() {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
}
